import { authenticatedApiFetch } from '../../common/helpers';
export const fetchLenderRegistrations = async (params) => {
    const response = await authenticatedApiFetch(
      "lender-registration",
      "GET",
      params
    );

    return (response?.data?.data ?? [])
};
